import { render } from "./Logistics.vue?vue&type=template&id=4a29bf5e"
import script from "./Logistics.vue?vue&type=script&lang=js"
export * from "./Logistics.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\a1bg493225\\Desktop\\logika\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__